import React, { useState } from 'react';
import { getInitials } from '../../../utils/getInitials.js';
import IconChecked from '../../images/IconChecked.jsx';
import IconClose from '../../images/IconClose.jsx';
import IconDots from '../../images/IconDots.jsx';
import IconEdit from '../../images/IconEdit.jsx';
import UserApproveConfirmation from './UserApproveConfirmation.jsx';
import UserDeleteConfirmation from './UserDeleteConfirmation.jsx';
import useCurrentUser from '../../../hooks/useCurrentUser.js';
import { PERMISSION_USERS } from '../../../utils/constants.js';

const UserListItem = ({ type, user, isLast }) => {
    const { permissions: userPermissions } = useCurrentUser();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [approveVisible, setApproveVisible] = useState(false);

    const openDrawer = () => {
        setDrawerOpen(true);
    };

    const closeDrawer = () => {
        if (drawerOpen) {
            setDrawerOpen(false);
        }
    };

    const handleApproveConfirmation = () => {
        closeDrawer();
        setApproveVisible(true);
    };

    const handleDeleteConfirmation = () => {
        closeDrawer();
        setDeleteVisible(true);
    };

    const initials = getInitials(user.name);

    return (
        <>
            <div className='bg-white relative overflow-hidden'>
                <div className='flex flex-col max-w-3xl w-full mx-auto px-4 pl-8' onClick={closeDrawer}>
                    <div
                        className={`flex py-[18px] items-center ${!isLast ? 'border-b border-solid border-theme1-tanTransparent' : ''}`}
                    >
                        <div className='rounded-full w-[48px] h-[48px] overflow-hidden mr-[16px]'>
                            <div className='w-full h-full bg-theme1-pale flex items-center justify-center'>
                                <div className='text-theme1-primary font-bold text-xl'>{initials}</div>
                            </div>
                        </div>
                        <div>
                            {type === 'approved' && user.role?.name && (
                                <div className='text-theme1-white text-[9px] font-[900] leading-none uppercase bg-theme1-gold rounded-[4px] flex-grow-0 px-2 py-1 inline-block overflow-hidden'>
                                    {user.role.name}
                                </div>
                            )}
                            <div className='text-theme1-primary font-bold text-base leading-none'>{user.name}</div>
                            {user.job_title && (
                                <div className='text-theme1-text1 text-[13px] font-[600] leading-none mt-1'>
                                    {user.job_title}
                                </div>
                            )}

                            {user.company && (
                                <div className='text-theme1-text1 text-[14px] font-bold leading-none mt-1'>
                                    {user.company}
                                </div>
                            )}
                        </div>
                        {(!!userPermissions[PERMISSION_USERS]?.delete ||
                            !!userPermissions[PERMISSION_USERS]?.update) && (
                            <button type='button' className='ml-auto' onClick={openDrawer}>
                                <IconDots className='fill-theme1-text1' />
                            </button>
                        )}
                    </div>
                </div>

                <div
                    className={`absolute flex gap-[2px] top-0 right-0 h-full bg-white transform transition-transform duration-300 ${
                        drawerOpen ? 'translate-x-0 shadow-lg' : 'translate-x-full'
                    }`}
                >
                    {!!userPermissions[PERMISSION_USERS]?.update && (
                        <button
                            className='w-[72px] flex-shrink-0 bg-theme1-primary py-2 rounded-[2px] flex items-center justify-center active:bg-theme1-brightRed'
                            onClick={handleApproveConfirmation}
                        >
                            {type === 'pending' && <IconChecked className='fill-white w-[43px] h-[38px]' />}
                            {type === 'approved' && <IconEdit className='stroke-white w-[33px] h-[28px]' />}
                        </button>
                    )}
                    {!!userPermissions[PERMISSION_USERS]?.delete && (
                        <button
                            className='w-[72px] flex-shrink-0 bg-theme1-primary py-2 rounded-[2px] flex items-center justify-center active:bg-theme1-brightRed'
                            onClick={handleDeleteConfirmation}
                        >
                            <IconClose className='fill-white w-[38px] h-[33px]' />
                        </button>
                    )}
                </div>
            </div>

            {approveVisible && (
                <UserApproveConfirmation
                    approveVisible={approveVisible}
                    setApproveVisible={setApproveVisible}
                    user={user}
                    type={type}
                />
            )}
            {deleteVisible && (
                <UserDeleteConfirmation deleteVisible={deleteVisible} setDeleteVisible={setDeleteVisible} user={user} />
            )}
        </>
    );
};

export default UserListItem;
